import React from 'react';
import CommandButtonComponent from "./CommandButtonComponent";
import CommandIdEnum from "../../enums/CommandIdEnums";
import { useViewerStateStore } from "../../store/viewerStateStore";
import "./CommandToolBarComponent.css";

const CommandToolBarComponent: React.FC = () => {
    const { isDebugMode } = useViewerStateStore();

    return (
        <div className="toolbar">
            <CommandButtonComponent
                commandId={CommandIdEnum.AddLengthDimension}
                commandNameResourceKey={"command.addLengthDimension.title"}
                commandIconPath={"/icons/dimension-temp.png"}
            />

            <CommandButtonComponent
                commandId={CommandIdEnum.AddTextAnnotation}
                commandNameResourceKey={"command.addTextAnnotation.title"}
                commandIconPath={"/icons/note-tool.svg"}
            />

            <CommandButtonComponent
                commandId={CommandIdEnum.AddAreaAnnotation}
                commandNameResourceKey={"command.addAreaAnnotation.title"}
                commandIconPath={"/icons/area-tool.svg"}
            />

            <CommandButtonComponent
                commandId={CommandIdEnum.AddRectangleAnnotation}
                commandNameResourceKey={"command.addRectangleAnnotation.title"}
                commandIconPath={"/icons/rectangle-tool.svg"}
            />

            <CommandButtonComponent
                commandId={CommandIdEnum.AddCircleAnnotation}
                commandNameResourceKey={"command.addCircleAnnotation.title"}
                commandIconPath={"/icons/circle-tool.svg"}
            />

            {isDebugMode && (
                <CommandButtonComponent
                    commandId={CommandIdEnum.AddChecklistItem}
                    commandNameResourceKey={"command.addChecklistItem.title"}
                    commandIconPath={"/icons/check.svg"}
                />
            )}
            
            {isDebugMode && (
                <CommandButtonComponent
                    commandId={CommandIdEnum.RemoveFromDocument}
                    commandNameResourceKey={"command.removeFromDocument.title"}
                    commandIconPath={"/icons/bin-temp.png"}
                />
            )}

        </div>
    );
};

export default CommandToolBarComponent;
